// extracted by mini-css-extract-plugin
export var bannerContent = "catalog-module--banner-content--d5b1f";
export var container = "catalog-module--container--43656";
export var mainHeading = "catalog-module--main-heading--ad95a";